import React from 'react';
import {LineChart} from '@mui/x-charts/LineChart';
import styled from "styled-components";
import dayjs from "dayjs";

const WrapperStyled = styled.div`
    padding: 10px;
    position: relative;
    width: 100%;
    height: 100%;
`;

const WeightGraph = ({data}) => {
    const xLabels = [];
    const deltaData = [];

    data.forEach(pp => {
        xLabels.push(dayjs(pp.time).format("H:mm:ss"));
        deltaData.push(pp.deltaWeight);
    });

    return (
        <WrapperStyled>
            <LineChart
                series={[
                    // {data: deltaData, label: 'Delta', area: true, stack: 'total'},
                    {data: deltaData, label: 'Delta'},
                ]}
                xAxis={[{scaleType: 'point', data: xLabels}]}
            />
        </WrapperStyled>
    );
};

export default WeightGraph;